import './style/signup.css';
import React, { useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
import Header from './header';
import Footer from './footer';

const Signup = (props) => {
  
    const [uname, setName] = useState("");
    const [uemail, setEmail] = useState("");
    const [umobile, setmobile] = useState("");
    const [upass, setPass] = useState("");
    const [npass, setCPass] = useState("");
    const [uaddress, setAddress] = useState("");
    const [msg, setMessage] = useState("");
    // const [status, setStatus] = useState(false);
    // const [errors, setErrors] = useState(["","","","","",""]);
    const [error0, setError0] = useState("");
    const [valid0, setValid0] = useState(true);
    const [error1, setError1] = useState("");
    const [valid1, setValid1] = useState(true);
    const [error2, setError2] = useState("");
    const [valid2, setValid2] = useState(true);
    const [error3, setError3] = useState("");
    const [valid3, setValid3] = useState(true);
    const [error4, setError4] = useState("");
    const [valid4, setValid4] = useState(true);
    const [error5, setError5] = useState("");
    const [valid5, setValid5] = useState(true);

    const onChangeName = (e) => setName(e.target.value);
    const onChangeEmail = (e) => setEmail(e.target.value);
    const onChangeMobile = (e) => setmobile(e.target.value);
    const onChangePass = (e) => setPass(e.target.value);
    const onChangeCPass = (e) => setCPass(e.target.value);
    const onChangeAddress = (e) => setAddress(e.target.value);

    const onBlurName = (e) => {
        // setValid[3](false);
        if (!uname) {
            setValid0(false);
            //setErrors({"name":"Please enter your name."});
            setError0("Please enter your name.");
          }
          else{
            setValid0(true);
            setError0("");
          }
          if (typeof uname !== "undefined") {
            // const re = /^\S*$/;
            // const re =/^[a-zA-Z][a-zA-Z\\s]+$/;
            const re = /^[a-zA-Z ]{2,40}$/;
            if(uname.length < 3 || !re.test(uname)){
                setValid0(false);
               // setErrors({"name":"Please enter valid name."});
               setError0("Please enter valid name.");
            }
            else{
                setValid0(true);
                setError0("");
              }
          }
          
    }
    const onBlurEmail = (e) => {
        if (!uemail) {
            setValid1(false);
            setError1("Please enter your email Address.");
            //setErrors({"name":"Please enter valid name."});
          }
          else{
            setValid1(true);
            setError1("");
          }
           if (typeof uemail !== "undefined") {        
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(uemail)) {
              setValid1(false);
              setError1("Please enter valid email address.");
              //setErrors({"name":"Please enter valid name."});
            }
          }
          else{
            setValid1(true);
            setError1("");
          }
    }
     const onBlurMobile = (e) => {	
    //    mobnoexp = /^[6789][0-9]{9}$/;
    //var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
       /*
       ^       #Match the beginning of the string
      (7|8|9)  #Match a 7, 8 or 9 digit
      \d       #Match a digit (0-9 and anything else that is a "digit")
      {9}      #Repeat the previous "\d" 9 times (9 digits)
      $        #Match the end of the string
       */
      //    var mobno = document.getElementById("mobno").value;
        //  alert(umobile);
        if (!umobile) {
            setValid2(false);
            setError2("Please enter your phone number.");
            //setErrors({"name":"Please enter valid name."});
          }
          else{
            setValid2(true);
            setError2("");
          }
           if (typeof umobile !== "undefined") {
            var pattern = new RegExp(/^[0-9\b]+$/);
            if (!pattern.test(umobile)) {
                setValid2(false);
              setError2("Please enter only number.");
              //setErrors({"name":"Please enter valid name."});
            }
            else{
                setValid2(true);
                setError2("");
              }
            if(umobile.length !== 10){
                setValid2(false);
              setError2("Please enter valid phone number.");
              //setErrors({"name":"Please enter valid name."});
            }
            else{
                setValid2(true);
                setError2("");
              }
          }
      }
      const onBlurAddress = (e) => {

        if (!uaddress) {
            setValid3(false);
            setError3("Please enter your address.");
          }
          else{
            setValid3(true);
            setError3("");
          }
    }
    const onBlurPass = (e) => {
        if (!upass) {
            setValid4(false);
            setError4("Please enter your password.");
            //setErrors({"name":"Please enter valid name."});
          }
          else{
            setValid4(true);
            setError4("");
          }
           if (typeof upass !== "undefined") {
            if(upass.length < 6){
                setValid4(false);
                setError4("Please add at least 6 charachter.");
                //setErrors({"name":"Please enter valid name."});
            }
          }
          else{
            setValid4(true);
            setError4("");
          }
          if (npass) {   
            if (upass !== npass) {
                setValid5(false);
              setError5("Passwords don't match.");
            }
            else{
                setValid5(true);
                setError5("");
              }
          }
    }
    const onBlurCPass = (e) =>{
        
        if (!npass) {
            setValid5(false);
            setError5("Please confirm your password.");
          } 
          else{
            setValid5(true);
            setError5("");
          }
        //   if(npass.length < 6){
        //     setValid({"confirm_password":false});
        //     errors["confirm_password"] = "Please add at least 6 charachter.";
        //     //setErrors({"name":"Please enter valid name."});
        // }
        // else{
        //     setValid({"confirm_password":true});
        //     errors["confirm_password"] = "";
        //   }
          if (typeof upass !== "undefined" && typeof npass !== "undefined") {   
            if (upass !== npass) {
                setValid5(false);
              setError5("Passwords don't match.");
            }
            else{
                setValid5(true);
                setError5("");

              }
          }
    }

    const handleSubmit =  (evt) => {
        if(valid0===false|| valid1===false || valid2===false || valid3===false || valid4===false || valid5===false)
            setMessage("ENTER VALID DATA");
        else
        {
            evt.preventDefault();
        console.log(`Form submitted:`);
        console.log(`NAME: ${uname}`);
        console.log(`EMAIL: ${uemail}`);

        axios.get('https://akshatngupta-bike-rental.herokuapp.com/user/search/' + uemail)
        .then(res => {
            setMessage('USER ALREADY EXISTS')
        })
        .catch(err  => {
            const info = {
              empname: uname,
              empemail: uemail.toLowerCase(),
              empmobile: umobile,
              emppass: upass,
              empaddress: uaddress
          }
          
           axios.post('https://akshatngupta-bike-rental.herokuapp.com/user/register', info)
              .then(res => {
                  console.log(res.data)
                  setMessage('REGISTRATION SUCCESSFUL')
              });
          
        })

        setName('')
        setEmail('')
        setmobile('')
        setPass('')
        setCPass('')
        setAddress('')
        setError0("")
        setValid0(true)
        setError1("")
        setValid1(true)
        setError2("")
        setValid2(true)
        setError3("")
        setValid3(true)
        setError4("")
        setValid4(true)
        setError5("")
        setValid5(true)
        }
    // else setMessage('INVALID DATA INPUT')
}
  
  return (
    <div>
    <Header />
    <span>
    <div className='main'>
        <div className='container'>
            <div className='bike-container'>
                <div className='bg-color'>
                    <div className='bike'>
                        <img src={require(`../assets/duke.png`)} alt='' />
                        </div>
                        <div className='form2'>
                        <form onSubmit={handleSubmit} >
                            <b>
						    <h3>Register</h3></b>
                            <b style={{ color: "brown" }}> {msg}</b>
							<p><label className="labels">Name</label></p>
							<input type="text" className="form-control" value={uname} onBlur={onBlurName} onChange={onChangeName} placeholder="Enter Name" required />
                            <div><b className="text-danger" style={{ color: "red" }}>{error0}</b></div>
                            <label>Email</label>
							<input type="email" className="form-control" value={uemail} onBlur={onBlurEmail} onChange={onChangeEmail} placeholder="Enter Email" required/>
							<div><b className="text-danger" style={{ color: "red" }}>{error1}</b></div>
                            <label>Mobile No.</label>
							<input type="number" className="form-control" value={umobile} onBlur={onBlurMobile}onChange={onChangeMobile} placeholder="Enter Mobile No" required />
							<div><b className="text-danger" style={{ color: "red" }}>{error2}</b></div>
                            <label>Address</label>
							<input type="address" className="form-control" placeholder="Enter Address" value={uaddress} onBlur={onBlurAddress} onChange={onChangeAddress} required/>
                            <div><b className="text-danger" style={{ color: "red" }}>{error3}</b></div>
                            <label>Password</label>
                            <input type="password" className="form-control" placeholder="Enter password" value={upass} onBlur={onBlurPass} onChange={onChangePass} required/>
                            <div><b className="text-danger" style={{ color: "red" }}>{error4}</b></div>
                            <label>Confirm Password</label>
                            <input type="password" className="form-control" placeholder="Confirm password" value={npass} onBlur={onBlurCPass} onChange={onChangeCPass} required/>		
                            <div><b className="text-danger" style={{ color: "red" }}>{error5}</b></div>
                            {/* <div>====---------====</div> */}
                            <button type="submit" id="btnSubmit" className="Button3" value="REGISTER" >Register</button>
    
                            <p className="forgot-password text-center">
							Already registered<Link to="/signin"> <a>log in?</a></Link> <a>log in?</a>
						</p>
                        
					</form>
					</div>
            </div>
            </div>
        </div>
    </div>
    </span>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <br/>
    <Footer />
    </div>
  );
};
export default Signup;